export interface StorageAdapter {
  getItem(key: string): Promise<string | null>
  setItem(key: string, value: string): Promise<void>
  removeItem(key: string): Promise<void>
  clear(): Promise<void>
}

class LocalStorageAdapter implements StorageAdapter {
  async getItem(key: string): Promise<string | null> {
    return localStorage.getItem(key)
  }

  async setItem(key: string, value: string): Promise<void> {
    localStorage.setItem(key, value)
  }

  async removeItem(key: string): Promise<void> {
    localStorage.removeItem(key)
  }

  async clear(): Promise<void> {
    localStorage.clear()
  }
}

class SessionStorageAdapter implements StorageAdapter {
  async getItem(key: string): Promise<string | null> {
    return sessionStorage.getItem(key)
  }

  async setItem(key: string, value: string): Promise<void> {
    sessionStorage.setItem(key, value)
  }

  async removeItem(key: string): Promise<void> {
    sessionStorage.removeItem(key)
  }

  async clear(): Promise<void> {
    sessionStorage.clear()
  }
}

export class StorageManager {
  private adapter: StorageAdapter

  constructor(adapter: StorageAdapter = new LocalStorageAdapter()) {
    this.adapter = adapter
  }

  async get<T>(key: string): Promise<T | null> {
    try {
      const value = await this.adapter.getItem(key)
      return value ? JSON.parse(value) : null
    } catch {
      return null
    }
  }

  async set<T>(key: string, value: T): Promise<void> {
    await this.adapter.setItem(key, JSON.stringify(value))
  }

  async remove(key: string): Promise<void> {
    await this.adapter.removeItem(key)
  }

  async clear(): Promise<void> {
    await this.adapter.clear()
  }
}

export const storage = new StorageManager()
export const sessionStorageManager = new StorageManager(new SessionStorageAdapter())